import { render, staticRenderFns } from "./SigningOut.vue?vue&type=template&id=87ed491a&scoped=true&"
import script from "./SigningOut.vue?vue&type=script&lang=js&"
export * from "./SigningOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ed491a",
  null
  
)

export default component.exports